// import React, { useState, useEffect } from 'react';
// import bannerImage1 from '../../assets/images/Banners/WomensBanner.png';
// const Banner = () => {
//   const [currentSlide, setCurrentSlide] = useState(0);
  
//   const banners = [
//     {
//       id: 1,
//       title: "Desi Aura",
//       subtitle: "Slay away this festive season with glam Indianwear",
//       image: bannerImage1
//     },
//     {
//       id: 2,
//       title: "Festival Collection",
//       subtitle: "Discover the latest trends in ethnic wear",
//       // image: "https://images.unsplash.com/photo-1610030469983-98e550d6193c?w=1200&h=400&fit=crop"
//       image: bannerImage1
//     },
//     {
//       id: 3,
//       title: "Wedding Season",
//       subtitle: "Make every moment special with our exclusive collection",
//       // image: "https://images.unsplash.com/photo-1519741497674-611481863552?w=1200&h=400&fit=crop"
//       image: bannerImage1
//     }
//   ];

//   useEffect(() => {
//     const timer = setInterval(() => {
//       setCurrentSlide((prevSlide) => 
//         prevSlide === banners.length - 1 ? 0 : prevSlide + 1
//       );
//     }, 3000);

//     return () => clearInterval(timer);
//   }, [banners.length]);

//   return (
//     <div className="relative w-full h-[400px] overflow-hidden">
//       <div 
//         className="flex transition-transform duration-500 ease-in-out h-full"
//         style={{ transform: `translateX(-${currentSlide * 100}%)` }}
//       >
//         {banners.map((banner) => (
//           <div
//             key={banner.id}
//             className="relative w-full h-full flex-shrink-0"
//             style={{
//               backgroundImage: `url(${banner.image})`,
//               backgroundSize: 'cover',
//               backgroundPosition: 'center'
//             }}
//           >
//             {/* <div className="absolute inset-0 bg-gradient-to-r from-black/60 to-transparent">
//               <div className="flex flex-col justify-center h-full max-w-lg ml-16">
//                 <h1 className="text-5xl font-bold text-white mb-4">
//                   {banner.title}
//                 </h1>
//                 <p className="text-xl text-white mb-8 leading-relaxed">
//                   {banner.subtitle}
//                 </p>
//                 <button className="bg-white text-black px-8 py-3 rounded-md font-semibold hover:bg-gray-100 transition-colors duration-200 w-fit">
//                   SHOP NOW
//                 </button>
//               </div>
//             </div> */}
//           </div>
//         ))}
//       </div>
      
//       {/* Dots indicator */}
//       <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex gap-2">
//         {banners.map((_, index) => (
//           <button
//             key={index}
//             className={`w-3 h-3 rounded-full transition-all duration-200 ${
//               index === currentSlide ? 'bg-white w-8' : 'bg-white/50'
//             }`}
//             onClick={() => setCurrentSlide(index)}
//           />
//         ))}
//       </div>
//     </div>
//   );
// };

// export default Banner;

// import React, { useState, useEffect } from 'react';
// import bannerImage1 from '../../assets/images/Banners/WomensBanner.png';

// const Banner = () => {
//   const [currentSlide, setCurrentSlide] = useState(0);
  
//   const banners = [
//     {
//       id: 1,
//       image: bannerImage1
//     },
//     {
//       id: 2,
//       image: bannerImage1
//     },
//     {
//       id: 3,
//       image: bannerImage1
//     }
//   ];

//   useEffect(() => {
//     const timer = setInterval(() => {
//       setCurrentSlide((prevSlide) => 
//         prevSlide === banners.length - 1 ? 0 : prevSlide + 1
//       );
//     }, 3000);

//     return () => clearInterval(timer);
//   }, [banners.length]);

//   const handlePrevSlide = () => {
//     setCurrentSlide(currentSlide === 0 ? banners.length - 1 : currentSlide - 1);
//   };

//   const handleNextSlide = () => {
//     setCurrentSlide(currentSlide === banners.length - 1 ? 0 : currentSlide + 1);
//   };

//   return (
//     <div className="relative w-full overflow-hidden">
//       {/* Maintain aspect ratio container */}
//       <div className="relative w-full" style={{ paddingBottom: '40%' }}>
//         <div 
//           className="absolute inset-0 flex transition-transform duration-500 ease-in-out"
//           style={{ transform: `translateX(-${currentSlide * 100}%)` }}
//         >
//           {banners.map((banner) => (
//             <div
//               key={banner.id}
//               className="relative w-full h-full flex-shrink-0"
//             >
//               <img
//                 src={banner.image}
//                 alt={`Banner ${banner.id}`}
//                 className="absolute inset-0 w-full h-full object-fill"
//               />
//             </div>
//           ))}
//         </div>
//       </div>
      
//       {/* Navigation Arrows (Optional) */}
//       <button
//         onClick={handlePrevSlide}
//         className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white p-2 rounded-full shadow-md transition-all duration-200 opacity-0 hover:opacity-100"
//       >
//         <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
//         </svg>
//       </button>
      
//       <button
//         onClick={handleNextSlide}
//         className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white p-2 rounded-full shadow-md transition-all duration-200 opacity-0 hover:opacity-100"
//       >
//         <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
//         </svg>
//       </button>
      
//       {/* Dots indicator */}
//       <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex gap-2">
//         {banners.map((_, index) => (
//           <button
//             key={index}
//             className={`w-3 h-3 rounded-full transition-all duration-200 shadow-md ${
//               index === currentSlide ? 'bg-white w-8' : 'bg-white/50 hover:bg-white/70'
//             }`}
//             onClick={() => setCurrentSlide(index)}
//           />
//         ))}
//       </div>
//     </div>
//   );
// };

// export default Banner;

// import React, { useState, useEffect } from 'react';
// import bannerImage1 from '../../assets/images/Banners/WomensBanner.png';

// const Banner = ({ category }) => {
//   const [currentSlide, setCurrentSlide] = useState(0);
//   const [imageLoaded, setImageLoaded] = useState(false);
  
//   const banners = [
//     {
//       id: 1,
//       image: bannerImage1
//     },
//     {
//       id: 2,
//       image: bannerImage1
//     },
//     {
//       id: 3,
//       image: bannerImage1
//     }
//   ];

//   useEffect(() => {
//     const timer = setInterval(() => {
//       setCurrentSlide((prevSlide) => 
//         prevSlide === banners.length - 1 ? 0 : prevSlide + 1
//       );
//     }, 3000);

//     return () => clearInterval(timer);
//   }, [banners.length]);

//   // const handlePrevSlide = () => {
//   //   setCurrentSlide(currentSlide === 0 ? banners.length - 1 : currentSlide - 1);
//   // };

//   // const handleNextSlide = () => {
//   //   setCurrentSlide(currentSlide === banners.length - 1 ? 0 : currentSlide + 1);
//   // };

//   return (
//     <div className="relative w-full overflow-hidden bg-gray-100">
//       <div className="relative w-full">
//         {/* Hidden image to maintain aspect ratio */}
//         <img 
//           src={bannerImage1} 
//           alt="aspect ratio" 
//           className="w-full invisible"
//           onLoad={() => setImageLoaded(true)}
//         />
        
//         {/* Actual slider */}
//         {imageLoaded && (
//           <div 
//             className="absolute inset-0 flex transition-transform duration-500 ease-in-out"
//             style={{ transform: `translateX(-${currentSlide * 100}%)` }}
//           >
//             {banners.map((banner) => (
//               <div
//                 key={banner.id}
//                 className="w-full h-full flex-shrink-0"
//               >
//                 <img
//                   src={banner.image}
//                   alt={`Banner ${banner.id}`}
//                   className="w-full h-full object-cover"
//                 />
//               </div>
//             ))}
//           </div>
//         )}
//       </div>
      
//       {/* Navigation Arrows */}
//       {/* <button
//         onClick={handlePrevSlide}
//         className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white p-2 rounded-full shadow-md transition-all duration-200 md:opacity-0 md:hover:opacity-100"
//       >
//         <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
//         </svg>
//       </button>
      
//       <button
//         onClick={handleNextSlide}
//         className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white p-2 rounded-full shadow-md transition-all duration-200 md:opacity-0 md:hover:opacity-100"
//       >
//         <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
//         </svg>
//       </button> */}
      
//       {/* Dots indicator */}
//       <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex gap-2 z-10">
//         {banners.map((_, index) => (
//           <button
//             key={index}
//             className={`w-3 h-3 rounded-full transition-all duration-200 shadow-md ${
//               index === currentSlide ? 'bg-white w-8' : 'bg-white/50 hover:bg-white/70'
//             }`}
//             onClick={() => setCurrentSlide(index)}
//           />
//         ))}
//       </div>
//     </div>
//   );
// };

// export default Banner;


import React, { useEffect, useState } from "react";
import api from "../../common/apiClient";
import SummaryAPI from "../../common/SummaryApi";

const Banner = ({ category, rounded = false }) => {
  const [banners, setBanners] = useState([]);
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    if (!category) return;

    const fetchBanners = async () => {
      try {
        const res = await api({
          method: SummaryAPI.getBannersByCategory.method,
          url: SummaryAPI.getBannersByCategory.url(category)
        });

        setBanners(res.data.data || []);
        setCurrent(0);
      } catch (err) {
        console.error("Banner fetch failed", err);
        setBanners([]);
      }
    };

    fetchBanners();
  }, [category]);

  useEffect(() => {
    if (banners.length <= 1) return;

    const timer = setInterval(() => {
      setCurrent((prev) =>
        prev === banners.length - 1 ? 0 : prev + 1
      );
    }, 3000);

    return () => clearInterval(timer);
  }, [banners]);

  if (!banners.length) return null;

  return (
    <div className="bg-white">
    <div className={`
      relative w-full overflow-hidden
      ${rounded ? "rounded-xl" : ""}
    `}
    >
      <div
        className="flex transition-transform duration-500"
        style={{ transform: `translateX(-${current * 100}%)` }}
      >
        {banners.map((banner) => (
          <img
            key={banner._id}
            src={banner.image}
            alt={banner.title || "Banner"}
            className="w-full flex-shrink-0 object-cover"
          />
        ))}
      </div>

      {/* dots */}
      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex gap-2">
        {banners.map((_, i) => (
          <button
            key={i}
            onClick={() => setCurrent(i)}
            className={`h-2 rounded-full transition-all ${
              i === current ? "w-8 bg-white" : "w-2 bg-white/50"
            }`}
          />
        ))}
      </div>
    </div>
    </div>
  );
};

export default Banner;
